<template>
  <div class>
    <section class="summary-collapse">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="2">
          <div class="col-title" slot="title">
            出差
            <span class="slot-days">{{ subBody.BUSINESS_TOTAL }}</span>
          </div>
          <section
            v-for="(item, index) in subBody.BUSINESS"
            :key="index"
            class="summary"
          >
            <div>
              <p>
                <span class="p-name"
                  ><label>姓名：</label>{{ item.C_NAME }}</span
                >
                <span class="p-title"
                  ><label>工号：</label>{{ item.EMPLID }}</span
                >
              </p>
              <p>
                <span class="p-name"
                  ><label>职位：</label>{{ item.POSN_DESCR }}</span
                >
                <span class="p-title"
                  ><label>部门：</label>{{ item.DEPT_DESCR }}</span
                >
                <!-- <label>{{ item.POSN_DESCR }}<span class="posn-span"></span>{{ item.DEPT_DESCR }}</label> -->
              </p>
              <p>
                <span
                  ><label>出差开始时间：</label
                  >{{ item.BGIN_DT | datefmt }}</span
                >
                <span class="p-title"
                  ><label>结束时间：</label>{{ item.END_DT | datefmt }}</span
                >
              </p>
              <p>
                <span><label>出差时长：</label>{{ item.C_DURATION }}</span>
                <!--<span class="p-title"><label>出差目的地：</label>{{ item.未知 }}天</span>-->
              </p>
            </div>
          </section>
        </van-collapse-item>
      </van-collapse>
    </section>
  </div>
</template>

<script>
  import dateformat from '@/utils/dateformat';

  export default {
    props: ['subBody'],
    data() {
      return {
        activeNames: ['1']
      };
    },
    methods: {},
    filters: {
      datefmt(val) {
        if (!val) return '';
        return dateformat('yyyy/MM/dd', new Date(val));
      },
      timeFmt(val) {
        if (!val) return '';
        let nTime = parseFloat(val);
        if (isNaN(nTime)) return val;
        nTime = nTime / 60.0;
        return new Number(nTime).toFixed(1);
      }
    }
  };
</script>

<style lang="less" scoped>
  .summary-collapse {
    margin-top: 10px;
  }
  .col-title {
    font-size: 16px;
  }
  .slot-days {
    float: right;
    color: #b2b2b2;
    font-size: 16px;
  }
  .summary {
    margin: 10px 0px 0;
    /* padding: 10px 10px; */
    border-bottom: 1px dotted #aeb5c2;
    background: white;
    border-radius: 10px;
    div {
      font-size: 14px;
      line-height: 30px;
      p {
        span {
          color: black;
        }
        span.p-name {
          font-size: 14px;
        }
        span.p-title {
          float: right;
        }
        span.p-day {
          color: red;
        }
        label {
          color: #aaa !important;
        }
      }
    }
  }
</style>
